module.exports = __webpack_public_path__ + "static/media/construction.7c23d80b.svg";